const API_ACTION_STARTED = 'api/ACTION_STARTED';
const API_ACTION_SUCCEEDED = 'api/ACTION_SUCCEEDED';
const API_ACTION_FAILED = 'api/ACTION_FAILED';
const API_PATCH_DATA = 'api/PATCH_DATA';
const API_CLEAR_DATA = 'api/CLEAR';
const API_SET_PATH = 'api/SET_PATH';
const API_SET_SKILL_RECOMMENDATION_API_PATH =
  'api/SET_SKILL_RECOMMENDATION_API_PATH';
const API_SET_WIDGETID = 'api/SET_WIDGETID';
const API_SET_LOADING = 'api/SET_LOADING';
const API_NETWORK_IS_DOWN = 'api/SET_NETWORK_IS_DOWN';

export default {
  API_ACTION_STARTED,
  API_ACTION_SUCCEEDED,
  API_ACTION_FAILED,
  API_PATCH_DATA,
  API_CLEAR_DATA,
  API_SET_PATH,
  API_SET_WIDGETID,
  API_SET_SKILL_RECOMMENDATION_API_PATH,
  API_SET_LOADING,
  API_NETWORK_IS_DOWN
};
